import { Component, OnInit } from '@angular/core';
import {VnaCampaignService} from '../../services/vna-campaign.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {ModalService} from 'ngx-dynamic-modal';
import {VnaCampaignActionEditComponent} from '../../modals/vna-campaign-action-edit/vna-campaign-action-edit.component';
import {VnaCampaignActionFilePreviewComponent} from '../../modals/vna-campaign-action-file-preview/vna-campaign-action-file-preview.component';

import Swal, {SweetAlertType} from 'sweetalert2';
import * as _ from 'underscore';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-vna-campaign-actions',
  templateUrl: './vna-campaign-actions.component.html',
  styleUrls: ['./vna-campaign-actions.component.scss']
})
export class VnaCampaignActionsComponent implements OnInit {

    private lastPkCamp: number;

    actions: Array<Object> = [];
    enabled: boolean = false;

    downloadingActionReport: Object = {};
    reportData: Object = {};

    constructor(private campHandler: VnaCampaignService, private activatedRoute: ActivatedRoute, private router: Router, private messaging: MessagingService, private modalHandler: ModalService, private alertService: AlertaService) {
    }


    downloadActionReport(row: Object): void {

        this.downloadingActionReport[row['pk']] = true;
        let type: SweetAlertType = 'question';
        let objectSwal = {
            'text' : 'If report exists, do you want to regenerate it?',
            'type' : type,
            'cancelButtonText' : 'No',
            'confirmButtonText' : 'Yes',
            'showCancelButton' : true
        };

        Swal(objectSwal).then((result) => {
            const regenerate: number = result.value;
            this
                .campHandler
                .downloadActionReport(row['vna_service_camp_pk'], row['pk'], regenerate)
                .subscribe(
                    (r) => {
                        (r.rows == 0)
                            ? this.alertService.addAlert('warning', 'There are no rows for this action')
                            : this.reportData = r
                        ;

                        this.downloadingActionReport[row['pk']] = false;
                    }
                )
        });

    }

    downloadFile(row: Object): void {
      this.enabled = true;
      this.campHandler.downloadActionFile(row['pk']).subscribe(
        (r: any) => {
          console.log(r);
          const blob = new Blob([r], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          this.enabled = false;
        }
      )
    }

    reporting(row: Object): void {
        this.router.navigateByUrl('phone/config/campaign/' + row['vna_service_camp_pk'] + '/action/' + row['pk'] + '/reporting');
    }

    onFileDownloaded(e: any): void {
        this.reportData = {};
    }

    modalCallback(carrier: Object): void {
        if(carrier['reload_actions']){
            this.getCampaignActions();
        }
    }

    newAction(): void {
        this.modalHandler.addDynamicComponent(VnaCampaignActionEditComponent, {'pk_camp' : this.lastPkCamp}, (res) => {
            this.modalCallback(res)
        });
    }

    editAction(row: Object): void {
        this.modalHandler.addDynamicComponent(VnaCampaignActionEditComponent, row, (res) => {
            this.modalCallback(res)
        });
    }

    editActionConfig(row: Object): void {
        this.router.navigateByUrl('phone/config/campaign/' + row['vna_service_camp_pk'] + '/action/' + row['pk']);
    }

    removeAction(row: Object): void {
        this.enabled = true;
        this.campHandler.removeAction(row['pk']).subscribe(
            (result) => {
                let idx = _.findIndex(this.actions, (o) => { return o.pk === row['pk'] });
                this.actions.splice(idx, 1);
                this.enabled = false;
                Swal({ type: 'success', title: 'Action performed', text: 'Action has been removed successfully'});
            }
        )
    }

    loadActionOnServer(row: Object): void {
        this.enabled = true;
        this.campHandler.actionToServer(row['pk']).subscribe(
            (result) => {
                Swal({ type: 'success', title: 'Action performed', text: 'Action has been sent to server to be processed'});
                this.getCampaignActions();
            }
        )
    }

    previewActionFile(row: Object): void {
        this.modalHandler.addDynamicComponent(VnaCampaignActionFilePreviewComponent, row, (res) => {
            this.modalCallback(res)
        })
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe( params => {
            this.lastPkCamp = params['pkc'];
            this.getCampaignActions();
        });

        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected && !result.isTheFirst()){
                    this.router.navigateByUrl('phone/config/campaigns');
                }
            }
        )
    }

    private getCampaignActions(): void {
        this.enabled = true;
        this.campHandler.findCampaignActions(this.lastPkCamp).subscribe(
            (result) => {
                this.actions = result;
                this.actions.forEach( (o) => {
                    this.downloadingActionReport[o['pk']] = false;
                });

                this.enabled = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/vna-campaign-actions/vna-campaign-actions.component.ts